const plugins = require('../utils/plugins');

/*-----------------------
    EXP TO NEXT LEVEL
-----------------------*/
plugins.createProgressBar({
  container: '#exp-to-next-level',
  height: 6,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#exp-to-next-level',
  height: 6,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 200,
    stop: 162
  },
  linkText: true,
  linkUnits: 'exp',
  invertedProgress: true,
  animateOnScroll: true
});

/*----------------
    BADGE ITEM
----------------*/
plugins.createProgressBar({
  container: '#badge-bronze',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-bronze',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 1,
    stop: 1
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-silver',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-silver',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 100,
    stop: 100
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-gold',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-gold',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 500,
    stop: 461
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-platinum',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-platinum',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 1000,
    stop: 461
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-traveller',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-traveller',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 5,
    stop: 4
  },
  invertedProgress: true,
  linkText: true,
  linkUnits: 'topics',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-caffeinated',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-caffeinated',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 1,
    stop: 0
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-upowered',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-upowered',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 50,
    stop: 42
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-scientist',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-scientist',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 1,
    stop: 1
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-ncreature',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-ncreature',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 100,
    stop: 100
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-warrior',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-warrior',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 1,
    stop: 1
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-liked',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-liked',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 500,
    stop: 462
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-sloved',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-sloved',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 1000,
    stop: 462
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-qconq',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-qconq',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 10,
    stop: 4
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-villain',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-villain',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 100,
    stop: 89
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-age',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-age',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 730,
    stop: 605
  },
  invertedProgress: true,
  linkText: true,
  linkUnits: 'days',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-tstruck',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-tstruck',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 50,
    stop: 41
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-uexp',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-uexp',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 20,
    stop: 17
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-globet',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-globet',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 10,
    stop: 8
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-verifieds',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-verifieds',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 1,
    stop: 1
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-gempost',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-gempost',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 1,
    stop: 0
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-peoplesp',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-peoplesp',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 200,
    stop: 181
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-rulerm',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-rulerm',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 5,
    stop: 1
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-marketeer',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-marketeer',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 10,
    stop: 7
  },
  invertedProgress: true,
  linkText: true,
  linkUnits: 'items',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-tycoon',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-tycoon',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 100,
    stop: 32
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-mightiers',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-mightiers',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 50,
    stop: 26
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-phantom',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-phantom',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 1,
    stop: 1
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-forumsf',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-forumsf',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 20,
    stop: 13
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-fcultivator',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-fcultivator',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 100,
    stop: 33
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-splanner',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-splanner',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 25,
    stop: 9
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-collector',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-collector',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 5,
    stop: 2
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-prophoto',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-prophoto',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 500,
    stop: 24
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-rmachine',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-rmachine',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 50,
    stop: 41
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-bronzec',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-bronzec',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 1,
    stop: 1
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-silverc',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-silverc',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 1,
    stop: 1
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-goldc',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-goldc',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 1,
    stop: 1
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

plugins.createProgressBar({
  container: '#badge-platinumc',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#badge-platinumc',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 1,
    stop: 0
  },
  linkText: true,
  linkUnits: '/',
  emptyText: 'locked',
  completeText: 'unlocked!'
});

/*-------------------
    QUEST PREVIEW
-------------------*/
plugins.createProgressBar({
  container: '#quest-preview-nth',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#quest-preview-nth',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 100,
    stop: 65
  },
  animateOnScroll: true
});

plugins.createProgressBar({
  container: '#quest-preview-sk',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#quest-preview-sk',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 100,
    stop: 85
  },
  animateOnScroll: true
});

plugins.createProgressBar({
  container: '#quest-preview-bp',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#quest-preview-bp',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 100,
    stop: 32
  },
  animateOnScroll: true
});

plugins.createProgressBar({
  container: '#quest-preview-htp',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#quest-preview-htp',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 100,
    stop: 0
  },
  animateOnScroll: true
});

plugins.createProgressBar({
  container: '#quest-preview-sm',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#quest-preview-sm',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 100,
    stop: 49
  },
  animateOnScroll: true
});

plugins.createProgressBar({
  container: '#quest-sk',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#quest-sk',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 8,
    stop: 7
  },
  linkText: true,
  linkUnits: '/'
});

plugins.createProgressBar({
  container: '#quest-fu',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#quest-fu',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 50,
    stop: 50
  },
  linkText: true,
  linkUnits: '/'
});

plugins.createProgressBar({
  container: '#quest-nth',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#quest-nth',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 100,
    stop: 67
  },
  linkText: true,
  linkUnits: '%'
});

plugins.createProgressBar({
  container: '#quest-sm',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#quest-sm',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 10,
    stop: 5
  },
  linkText: true,
  linkUnits: '/'
});

plugins.createProgressBar({
  container: '#quest-line-ps',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#quest-line-ps',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 100,
    stop: 100
  },
  linkText: true,
  linkUnits: '%',
  animateOnScroll: true
});

plugins.createProgressBar({
  container: '#quest-line-nth',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#quest-line-nth',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 100,
    stop: 67
  },
  linkText: true,
  linkUnits: '%',
  animateOnScroll: true
});

plugins.createProgressBar({
  container: '#quest-line-fu',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#quest-line-fu',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 50,
    stop: 50
  },
  linkText: true,
  linkUnits: '/',
  animateOnScroll: true
});

plugins.createProgressBar({
  container: '#quest-line-ph',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#quest-line-ph',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 20,
    stop: 20
  },
  linkText: true,
  linkUnits: '/',
  animateOnScroll: true
});

plugins.createProgressBar({
  container: '#quest-line-tr',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#quest-line-tr',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 10,
    stop: 2
  },
  linkText: true,
  linkUnits: '/',
  animateOnScroll: true
});

plugins.createProgressBar({
  container: '#quest-line-sk',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#quest-line-sk',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 8,
    stop: 7
  },
  linkText: true,
  linkUnits: '/',
  animateOnScroll: true
});

plugins.createProgressBar({
  container: '#quest-line-bp',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#quest-line-bp',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 30,
    stop: 12
  },
  linkText: true,
  linkUnits: '/',
  animateOnScroll: true
});

plugins.createProgressBar({
  container: '#quest-line-htp',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#quest-line-htp',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 100,
    stop: 0
  },
  linkText: true,
  linkUnits: '%',
  animateOnScroll: true
});

plugins.createProgressBar({
  container: '#quest-line-sm',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#quest-line-sm',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 10,
    stop: 5
  },
  linkText: true,
  linkUnits: '/',
  animateOnScroll: true
});

/*------------------
    POLL RESULT
------------------*/
plugins.createProgressBar({
  container: '#poll-result-1',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#poll-result-1',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 100,
    stop: 62
  },
  linkText: true,
  linkUnits: '%'
});

plugins.createProgressBar({
  container: '#poll-result-2',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#poll-result-2',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 100,
    stop: 27
  },
  linkText: true,
  linkUnits: '%'
});

plugins.createProgressBar({
  container: '#poll-result-3',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#poll-result-3',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 100,
    stop: 11
  },
  linkText: true,
  linkUnits: '%'
});


/*---------------------
    POST ENGAGEMENT
---------------------*/
plugins.createProgressBar({
  container: '#post-engagement-1',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#post-engagement-1',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 100,
    stop: 89
  },
  linkText: true,
  linkUnits: '%',
  animateOnScroll: true
});

plugins.createProgressBar({
  container: '#post-engagement-2',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#post-engagement-2',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 100,
    stop: 74
  },
  linkText: true,
  linkUnits: '%',
  animateOnScroll: true
});

plugins.createProgressBar({
  container: '#post-engagement-3',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#post-engagement-3',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 100,
    stop: 53
  },
  linkText: true,
  linkUnits: '%',
  animateOnScroll: true
});

plugins.createProgressBar({
  container: '#post-engagement-4',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#post-engagement-4',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 100,
    stop: 48
  },
  linkText: true,
  linkUnits: '%',
  animateOnScroll: true
});

plugins.createProgressBar({
  container: '#post-engagement-5',
  height: 4,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#post-engagement-5',
  height: 4,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 100,
    stop: 21
  },
  linkText: true,
  linkUnits: '%',
  animateOnScroll: true
});

/*-----------------
    TOP COUNTRY
-----------------*/
plugins.createProgressBar({
  container: '#top-country-1',
  width: 178,
  height: 6,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#top-country-1',
  width: 178,
  height: 6,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 25362,
    stop: 25362
  },
  split: {
    parts: 30,
    gap: 2,
    color: '#1d2333'
  },
  linkText: true,
  linkUnits: false,
  animateOnScroll: true
});

plugins.createProgressBar({
  container: '#top-country-2',
  width: 178,
  height: 6,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#top-country-2',
  width: 178,
  height: 6,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 25362,
    stop: 18201
  },
  split: {
    parts: 30,
    gap: 2,
    color: '#1d2333'
  },
  linkText: true,
  linkUnits: false,
  animateOnScroll: true
});

plugins.createProgressBar({
  container: '#top-country-3',
  width: 178,
  height: 6,
  lineColor: '#293249'
});

plugins.createProgressBar({
  container: '#top-country-3',
  width: 178,
  height: 6,
  gradient: {
    colors: ['#40d04f', '#d9ff65']
  },
  scale: {
    start: 0,
    end: 25362,
    stop: 9567
  },
  split: {
    parts: 30,
    gap: 2,
    color: '#1d2333'
  },
  linkText: true,
  linkUnits: false,
  animateOnScroll: true
});